<template>
  <div :class="{'yxtbiz-ai-robot-demo__dialog--msg': true, 'is-question': true, 'fullscreen': fullscreen} ">
    <div class="is-content">
      <div class="question-msg font-size-16" ref="question">{{ msg }}</div>
      <msgToolBtn  @toolClick="toolClick"/>
    </div>
    <yxtf-portrait v-if="showPortrait" class="mt4 ml12" size="28px" :username="username" :imgUrl="userImgUrl"></yxtf-portrait>
  </div>
</template>

<script>
import msgToolBtn from './msgToolBtn.vue';
export default {
  name: 'Question',
  components: {
    msgToolBtn
  },
  props: {
    showPortrait: {
      type: Boolean,
      default: false
    },
    msg: {
      type: String,
      default: ''
    },
    fullscreen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      username: window.localStorage.getItem('username') || '',
      userImgUrl: window.localStorage.getItem('imgUrl') || '',
      menuVisible: false,
      rightMenuVisible: true
    };
  },
  methods: {
    toolClick(type) {
      if (type === 'search') {
        this.search();
      } else {
        this.copyText(this.$refs.question);
      }
    },
    copyText(copyDom) {
      // 创建text area
      const textArea = document.createElement('textarea');
      textArea.value = copyDom.innerText;
      textArea.style.position = 'absolute';
      textArea.style.opacity = '0';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select(); // 选中文本
      document.execCommand('Copy'); // 执行浏览器复制命令
      this.$message.success(this.$t('pc_biz_copy_success').d('复制成功！'));
    },
    search() {
      let pageUrl = `${window.location.origin}/search/#/gs/composite?keyword=${this.msg}`;
      window.open(pageUrl, '_blank');
    }
  }
};
</script>
